import React from "react";
import Modal from "../../app/UI/Modal/Modal";
import { connect } from "react-redux";

import { closeModal } from "./modalActions";
import UploadAirtime from "../airtime/Upload/uploadAirtime";

const actions = { closeModal };

const uploadAirtimeModal = ({ closeModal }) => {
  return (
    <Modal modalHeader="Upload Airtime" onClose={closeModal}>
      <UploadAirtime />
    </Modal>
  );
};

export default connect(
  null,
  actions
)(uploadAirtimeModal);
